export const debounce = (wait) => (cb) => {
  let timerId: ReturnType<typeof setTimeout>;
  return (...args) => {
    clearTimeout (timerId);
    timerId = setTimeout (() => cb (...args), wait);
  };
};

// Use
// $(this).on ('keyup', '.activity-bar-search input', debounce (500) ((e) => {
//   e.preventDefault ();
// }));